import * as $ from 'jquery';

class VideoController {
  constructor() {    
    $(document).ready(function() {
      if ($(".container.video-boodschap").length > 0) {
        $('html, body').animate({
          scrollTop: $(".container.video-boodschap").offset().top + 'px'
        });
      }
    });
  }
}
export { VideoController };